import lightGallery from "lightgallery";

import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgFullscreen from "lightgallery/plugins/fullscreen";

ko.bindingHandlers.lightGallery = {
    init(element) {
        const state = { lgInstance: null };
        element.__lightGalleryState = state;

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            state.lgInstance?.destroy(true);
            element.__lightGalleryState = null;
        });

        console.log('lightgallery loaded');
    },

    update(element, valueAccessor, allBindings, viewModel) {
        const state = element.__lightGalleryState || {};
        const value = ko.unwrap(valueAccessor()) || {};
        const options = ko.unwrap(value.options) || {};
        const events = value.events || {};

        // Vorherige Instanz aufräumen
        state.lgInstance?.destroy?.(true);

        // Optionen auch als data-lg-* setzen (für native Unterstützung)
        for (const [key, val] of Object.entries(options)) {
            const attrName = `data-lg-${key.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`)}`;
            element.setAttribute(attrName, val);
        }

        let opt = {
            selector: "a", // Standard: alle <a> im Container
            plugins: [lgThumbnail, lgZoom, lgFullscreen],
            licenseKey: '9CEEB2D0-5E1F-4211-852F-E3322309E5CB',
            ...options,
        };

        // Initialisieren
        state.lgInstance = lightGallery(element, opt);

        console.log(state.lgInstance);

        // Events binden
        for (const [evtName, callback] of Object.entries(events)) {
            if (typeof callback !== "function") continue;
            state.lgInstance.on(evtName, (...args) => callback.apply(viewModel, args));
        }

        element.__lightGalleryState = state;
    },
}